const HOVER_THIS = 'HOVER_THIS_';
const UNHOVER_THIS = 'UNHOVER_THIS';

function hoverThis(id, parent) {
  return {
    type: HOVER_THIS,
    id,
    parent,
  };
}

function unhoverThis(id) {
  return {
    type: UNHOVER_THIS,
    id,
  };
}


export {
  HOVER_THIS,
  UNHOVER_THIS,
  hoverThis,
  unhoverThis,
};



// WEBPACK FOOTER //
// ./src/redux/actions/option_hover.js